import { RvoProvider } from '../models';

/**
 * Checks if the given provider is a valid RVO provider.
 * @param provider - The provider string to check.
 */
export const isRvOProvider = (provider: string): boolean => {
  return provider in RvoProvider;
};
